import { useState } from 'react'

import GroupMenuItem from 'components/Participants/Group/GroupDropdown/GroupMenuItem'
import type { Group as GroupType } from 'containers/Participants/Redux/Reducer/InitialStateType'
import { getDefaultGroup } from 'components/Participants/Group/GetDefaultGroup'
import {
  setActiveGroup,
  setProjectsOfAGroup,
} from 'redux/slices/ParticipantGroups'
import {
  resetFilters,
  toggleHasFilterValueStatus,
} from 'redux/slices/FilterBuilder'
import { useGroupFiltersDispatch } from 'components/Participants/Group/GroupDropdown/UseGroupFiltersDispatch'
import { useAppDispatch } from 'redux/Hook'
import filterGroupsAPI from 'api/ApiActions/Groups/FilterByGroup'
import { resetQuestions as resetSignUpFormQuestions } from 'redux/slices/SignUpQuestions'

type LoadGroupsProps = {
  groups: GroupType[]
  handleToggle: () => void
  setDeleteGroupModalVisibility: (value: boolean) => void
  setDeleteGroup: (value: GroupType) => void
}

const LoadGroups = ({
  groups,
  handleToggle,
  setDeleteGroupModalVisibility,
  setDeleteGroup,
}: LoadGroupsProps) => {
  const [isMenuItemDisabled, setMenuItemDisabledStatus] = useState(false)

  const dispatch = useAppDispatch()

  const [showGroupRelatedFilters] = useGroupFiltersDispatch()

  const defaultGroup = getDefaultGroup()

  const handleMenuItemClick = async (group: GroupType) => {
    /*
     * 1. Disbale segment API call
     * 2. Disable the menu items
     * 3. Hide the dropdown
     * 4. Clear all filter values and selected filters
     * 5. reset signup form questions.
     */
    dispatch(toggleHasFilterValueStatus(false))
    setMenuItemDisabledStatus(true)
    handleToggle()
    dispatch(resetFilters())
    dispatch(resetSignUpFormQuestions())

    // For "All participants"
    if (group.id === '0') {
      dispatch(setActiveGroup(null))
      return
    }

    const selectedMenuItem = {
      id: group.id,
      name: group.name || defaultGroup.name,
      defaultSegment: group.defaultSegment,
    }

    await showGroupRelatedFilters(group)

    dispatch(setActiveGroup(selectedMenuItem))
    setMenuItemDisabledStatus(false)

    // Fetch associated project only for custom group
    if (!group.defaultSegment) {
      fetchProjectsAssociatedWithTheGroup(group)
    }
  }

  const fetchProjectsAssociatedWithTheGroup = async (group: GroupType) => {
    const payload = {
      groupId: group.id,
    }
    const response = await filterGroupsAPI.getProjectsInAGroup(payload)
    dispatch(setProjectsOfAGroup(response.data.data))
  }

  return (
    <>
      {groups.map((group: GroupType, index: number) => (
        <GroupMenuItem
          key={index}
          group={group}
          isMenuItemDisabled={isMenuItemDisabled}
          handleMenuItemClick={handleMenuItemClick}
          setDeleteGroupModalVisibility={setDeleteGroupModalVisibility}
          setDeleteGroup={setDeleteGroup}
          handleToggle={handleToggle}
        />
      ))}
    </>
  )
}

export default LoadGroups
